var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconFacebook(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.9894 46.6864C20.2822 45.3072 14.4409 38.6547 14.4409 30.6229C14.4409 21.6987 21.7425 14.3972 30.6667 14.3972C39.5909 14.3972 46.8925 21.6987 46.8925 30.6229C46.8925 38.6547 41.0512 45.3072 33.3439 46.6864L32.4515 45.9562H28.8819L27.9894 46.6864Z",
    fill: "url(#paint0_linear_37_12)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.9948 35.1661L37.7249 30.6229H33.4251V27.4589C33.4251 26.1608 33.9119 25.1873 35.859 25.1873H37.9683V21.0497C36.8325 20.8875 35.5344 20.7252 34.3986 20.7252C30.6667 20.7252 28.0706 22.9968 28.0706 27.0533V30.6229H24.0142V35.1661H28.0706V46.6053C28.963 46.7676 29.8554 46.8487 30.7478 46.8487C31.6403 46.8487 32.5327 46.7675 33.4251 46.6053V35.1661H36.9948Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_37_12",
    x1: 30.6677,
    y1: 45.7195,
    x2: 30.6677,
    y2: 14.3909,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0062E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#19AFFF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFacebook);
export default __webpack_public_path__ + "static/media/icon-facebook.8f9225e15d54e244b3de12627b62bbec.svg";
export { ForwardRef as ReactComponent };